import React, { Component } from 'react';
import Table from '../../../../commons/Table/Table';

export default class SMSHistoryList extends Component {
    state = {
        headers: [
            {key: 'id', label: 'id'},
            {key: 'receiver', label: 'Receiver'},
            {key: 'contact_number', label: 'Contact #'},
            {key: 'message', label: 'Message'},
            {key: 'created_at', label: 'Date'},
        ]
    };

    render() {
        return (
            <Table id={"smsHistoryTable"} headers={this.state.headers}
                   data={this.props.smsHistories} />
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/smsManager/tabs/SMSHistoryList.js
 **/